/*
 * HALO Navigation V14 — back/forward scroll restoration.
 * Replaces V10/V12/V13; do NOT load those versions in parallel.
 * Keeps a page hidden only while restoring an existing history entry.
 * Works for Home, Catalog, product pages, content pages and policies.
 */
(function () {
  'use strict';

  if (window.__haloNavigationV14) return;
  window.__haloNavigationV14 = true;

  var doc = document;
  var root = doc.documentElement;
  var PREFIX = 'halo.nav14.entry.';
  var ENTRY_KEY = '__haloNav14Entry';
  var MAX_AGE_MS = 30 * 60 * 1000;
  var MAX_WAIT_MS = 2200;
  var MIN_SETTLE_MS = 160;
  var currentEntryId = '';
  var restoring = false;
  var restoreTimeout = 0;
  var restoreFrame = 0;
  var lastAdjustment = 0;

  // This CSS is installed in <head>, before any page content is rendered.
  var css = doc.createElement('style');
  css.id = 'halo-navigation-v14-css';
  css.textContent =
    'html.halo-nav14-restoring body::after{' +
    'content:""!important;position:fixed!important;inset:0!important;' +
    'background:#FAF9F6!important;z-index:2147483647!important;' +
    'pointer-events:auto!important;opacity:1!important;' +
    'transition:none!important;animation:none!important;transform:none!important;}' +
    'html.halo-nav14-restoring,html.halo-nav14-restoring body{' +
    'scroll-behavior:auto!important;}';
  (doc.head || root).appendChild(css);

  function getPath() { return location.pathname + location.search; }
  function isEditor() {
    return (window.Shopify && window.Shopify.designMode) ||
      root.classList.contains('shopify-design-mode');
  }
  function setScrollMode(mode) {
    try { if ('scrollRestoration' in history) history.scrollRestoration = mode; }
    catch (error) { /* The browser can disable this API in some contexts. */ }
  }
  function navigationType() {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      return entry && entry.type || '';
    } catch (error) { return ''; }
  }
  function uniqueId() {
    return 'h' + Date.now().toString(36) + Math.random().toString(36).slice(2, 11);
  }
  function ensureEntry() {
    try {
      var existing = history.state;
      if (existing && typeof existing === 'object' &&
          typeof existing[ENTRY_KEY] === 'string') {
        currentEntryId = existing[ENTRY_KEY];
        return currentEntryId;
      }
      var next = existing && typeof existing === 'object' && !Array.isArray(existing) ?
        Object.assign({}, existing) : {};
      currentEntryId = uniqueId();
      next[ENTRY_KEY] = currentEntryId;
      // Preserve unrelated Shopify state, such as catalog sorting.
      history.replaceState(next, '', location.href);
    } catch (error) {
      if (!currentEntryId) currentEntryId = uniqueId();
    }
    return currentEntryId;
  }
  function readRecord() {
    var id = ensureEntry();
    try {
      var text = sessionStorage.getItem(PREFIX + id);
      if (!text) return null;
      var item = JSON.parse(text);
      if (!item || item.path !== getPath() || !Number.isFinite(item.y) ||
          !Number.isFinite(item.savedAt) || Date.now() < item.savedAt ||
          Date.now() - item.savedAt > MAX_AGE_MS) return null;
      return item;
    } catch (error) { return null; }
  }
  function saveRecord() {
    if (isEditor()) return null;
    var rails = [];
    var tracks = doc.querySelectorAll('.hfc-track');
    for (var i = 0; i < tracks.length; i++) {
      if (tracks[i].id) rails.push({ id: tracks[i].id, left: tracks[i].scrollLeft });
    }
    var record = {
      path: getPath(),
      savedAt: Date.now(),
      y: Math.max(0, window.scrollY || window.pageYOffset || 0),
      rails: rails,
      anchorId: '',
      anchorOffset: null
    };
    // Anchor the vertical position to the section visible at the time of departure.
    var sections = doc.querySelectorAll('[id^="shopify-section-"]');
    for (var j = 0; j < sections.length; j++) {
      var rect = sections[j].getBoundingClientRect();
      if (rect.top <= 125 && rect.bottom > 125) {
        record.anchorId = sections[j].id;
        record.anchorOffset = rect.top;
        break;
      }
    }
    try { sessionStorage.setItem(PREFIX + ensureEntry(), JSON.stringify(record)); }
    catch (error) { /* Native fallback if sessionStorage is unavailable. */ }
    return record;
  }
  function requiresRestore(record) {
    return !!record && (record.y > 24 || (record.rails || []).some(function (rail) {
      return Number(rail.left) > 3;
    }));
  }
  function cover() { root.classList.add('halo-nav14-restoring'); }
  function uncover() { root.classList.remove('halo-nav14-restoring'); }
  function scrollInstant(y) {
    try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
    catch (error) { window.scrollTo(0, y); }
  }
  function targetY(record) {
    var fallback = Math.max(0, Number(record.y) || 0);
    if (!record.anchorId || record.anchorOffset == null) return fallback;
    var anchor = doc.getElementById(record.anchorId);
    if (!anchor) return fallback;
    var absoluteTop = anchor.getBoundingClientRect().top +
      (window.scrollY || window.pageYOffset || 0);
    return Math.max(0, Math.round(absoluteTop - Number(record.anchorOffset)));
  }
  function restoreRails(record) {
    if (!Array.isArray(record.rails)) return;
    for (var i = 0; i < record.rails.length; i++) {
      var value = record.rails[i];
      var rail = value && doc.getElementById(value.id);
      if (!rail || Math.abs(rail.scrollLeft - Number(value.left)) <= 2) continue;
      var oldBehavior = rail.style.scrollBehavior;
      rail.style.scrollBehavior = 'auto';
      rail.scrollLeft = Number(value.left) || 0;
      rail.style.scrollBehavior = oldBehavior;
    }
  }
  function stopRestoring() {
    restoring = false;
    if (restoreTimeout) window.clearTimeout(restoreTimeout);
    if (restoreFrame) window.cancelAnimationFrame(restoreFrame);
    restoreTimeout = 0;
    restoreFrame = 0;
    uncover();
    setScrollMode('auto');
  }
  function restore(record) {
    if (restoring) return;
    restoring = true;
    cover();
    // Prevent a late native scroll from undoing the position restored beneath the cover.
    setScrollMode('manual');
    var stableFrom = 0;
    var previousTarget = null;
    var started = performance.now();

    function step(timestamp) {
      if (!restoring) return;
      if (!doc.body) {
        restoreFrame = window.requestAnimationFrame(step);
        return;
      }
      var target = targetY(record);
      var maxScroll = Math.max(0, root.scrollHeight - window.innerHeight);
      var desired = Math.min(target, maxScroll);
      var scroll = window.scrollY || window.pageYOffset || 0;
      var reachable = maxScroll >= target - 3;

      // Adjust only if needed, with a minimum gap between adjustments.
      if (reachable && Math.abs(scroll - desired) > 2 &&
          (lastAdjustment === 0 || timestamp - lastAdjustment >= 64)) {
        scrollInstant(desired);
        lastAdjustment = timestamp;
        scroll = window.scrollY || window.pageYOffset || 0;
      }
      restoreRails(record);
      var aligned = reachable && Math.abs(scroll - desired) <= 3;
      var geometryStable = previousTarget !== null &&
        Math.abs(previousTarget - target) <= 2;
      if (aligned && geometryStable) {
        if (!stableFrom) stableFrom = timestamp;
      } else {
        stableFrom = 0;
      }
      previousTarget = target;
      // Wait beyond two frames so the browser can finish settling its layout.
      if (stableFrom && timestamp - stableFrom >= MIN_SETTLE_MS) {
        stopRestoring();
      } else if (timestamp - started >= MAX_WAIT_MS) {
        // Never leave the storefront blocked indefinitely on a faulty connection.
        stopRestoring();
      } else {
        restoreFrame = window.requestAnimationFrame(step);
      }
    }
    restoreTimeout = window.setTimeout(stopRestoring, MAX_WAIT_MS + 200);
    restoreFrame = window.requestAnimationFrame(step);
  }

  // Each history entry gets its own key, so revisiting Catalog does not overwrite
  // an earlier Catalog location in the same Back/Forward stack.
  ensureEntry();
  var initial = readRecord();
  if (!isEditor() && navigationType() === 'back_forward' && requiresRestore(initial)) {
    cover(); // On a freshly reloaded history entry, this runs before first paint.
    setScrollMode('manual');
  } else {
    setScrollMode('auto');
  }

  // A real page navigation, not an AJAX sort, saves its state at pagehide.
  // With BFCache the covered document is kept covered until pageshow restores it.
  window.addEventListener('pagehide', function () {
    if (isEditor()) return;
    var record = saveRecord();
    if (requiresRestore(record)) {
      setScrollMode('manual');
      cover();
    } else {
      uncover();
      setScrollMode('auto');
    }
  });
  window.addEventListener('pageshow', function (event) {
    if (isEditor()) { stopRestoring(); return; }
    var record = readRecord();
    var isReturn = !!(event && event.persisted) ||
      navigationType() === 'back_forward';
    if (isReturn && requiresRestore(record)) restore(record);
    else stopRestoring();
  });
  // AJAX sorting can replace the history state without loading a new document.
  // Do not move the viewport when only URL parameters change.
  window.addEventListener('popstate', function () {
    ensureEntry();
  });
  doc.addEventListener('shopify:section:load', function () {
    if (isEditor()) stopRestoring();
  });
})();